import React, { useState } from "react";
import "./OTP.css";
import AuthLayout from "../AuthLayout/AuthLayout";
import { Button } from "antd";

const OTPVerify = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [timer, setTimer] = useState(120);
  const [verificationMatched, setVerificationMatched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault(); // Prevent default paste behavior
    const pastedData = e.clipboardData.getData("text").trim();

    // Only process if pasted data matches the expected length
    if (pastedData.length <= otp.length) {
      const updatedOtp = [...otp];
      for (let i = 0; i < pastedData.length; i++) {
        updatedOtp[i] = pastedData[i];
      }
      setOtp(updatedOtp);

      // Optionally focus the last filled input
      const lastIndex = pastedData.length - 1;
      const lastInput = document.querySelectorAll(".otp-field")[lastIndex];
      if (lastInput) lastInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      // Move focus to the previous input if it exists
      if (index > 0) {
        const prevInput = document.querySelectorAll(".otp-field")[index - 1];
        if (prevInput) {
          prevInput.focus();
          const updatedOtp = [...otp];
          updatedOtp[index - 1] = ""; // Clear the value of the previous input
          setOtp(updatedOtp);
        }
      }
    }
  };

  return (
    <AuthLayout>
      <div className="otp-verify-container">
        <h1>OTP Verification</h1>
        <p>Enter the verification code that has been sent to your email</p>
        <span>example*****@example.com</span>
      </div>
      <div className="otp-container">
        {otp.map((data, index) => {
          return (
            <input
              className="otp-field"
              type="text"
              name="otp"
              maxLength="1"
              placeholder=""
              key={index}
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onFocus={(e) => e.target.select()}
              onPaste={(e) => handlePaste(e)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          );
        })}
      </div>
      <div className="otp-verify-footer">
        <p>
          OTP Expires in <span id="timer">({timer})</span> seconds
        </p>
        <p className="resend-otp">
          Haven't received the OTP code ? <span id="resend">Resend</span>
        </p>
        <Button htmlType="submit" type="primary" className="signin-btn" disabled={verificationMatched || isLoading}>
          {isLoading ? "Verifying..." : "Verify"}
        </Button>
      </div>
    </AuthLayout>
  );
};

export default OTPVerify;
